import { useEffect } from 'react'
import { StorageModule } from '../../modules/storage';
import { userModule } from '../../modules/user';

interface Props {
    history: any;
}

const Home = (props: Props) => {
    useEffect(() => {
        init()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const init = async (): Promise<any> => {
        try {
            let userInfo: any = StorageModule.getUser().user;
            userModule.redirectPageByUser(userInfo, props.history);
        } catch(error) {
            props.history.push('/login')
        }
    }

    return (
        <div>11</div>
    )
}

export default Home
